import { ReactElement, useMemo } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { generateTrackingId, isNil } from "client/Misc/utils";
import { TimeZone } from "client/DateAndTime/timezones";
import { EmailListItem } from "client/Features/Layout/TitleBar/GlobalSearch/Items/EmailListItem";
import { useEmailNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useEmailNavigationHandler";
import { convertAppColor } from "../../Persistence/convertPersistedData";
import { AppColorKind, AppColorViewModel } from "client/Api/Apps/common";

export type EmailItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Email>;
	navigationIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
};

export const EmailItemView = (props: EmailItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove,
		timezone
	} = props;

	const {
		emailId,
		parentFolderName,
		receivedDateTime,
		subject,
		ownerName,
		color: persistedColor
	} = item.email;

	const color = useMemo(
		(): AppColorViewModel => {
			if (isNil(persistedColor)) {
				return { kind: AppColorKind.Primary };
			}

			return convertAppColor(persistedColor);
		},
		[persistedColor]
	);

	const executeHandler: () => void = useEmailNavigationHandler({
		emailId,
		recentlyOpenedItem: item
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("email-item", `|${emailId}`)}
		>
			<EmailListItem
				emailId={emailId}
				ownerName={ownerName}
				parentFolderName={parentFolderName}
				receivedDateTime={receivedDateTime}
				subject={subject}
				timezone={timezone}
				onRemove={onRemove}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
				color={color}
			/>
		</SearchListItem>
	);
};
EmailItemView.displayName = "EmailItemView";